/* eslint-env browser */
/* eslint-disable func-names */
/**
 * Webinar Series Component
 * Converted from jQuery to native JavaScript while preserving original behavior
 */
import { Component, registerComponent } from 'js/component.js';

const componentName = 'webinar-series';

class WebinarSeries extends Component {

    /**
     * Initialize Component
     */
    init() {
        // Add sort-value attr to ul's (from sort-date attr in li)
        const webinarStartDates = document.querySelectorAll('.webinar-instance__startDate');
        webinarStartDates.forEach((startDateElement) => {
            const webinarDateStr = startDateElement.dataset.webinarDate;
            const sortVal = Date.parse(webinarDateStr.substring(0, 16));
            const todaysDate = new Date();
            const pastOrFuture = sortVal < Date.parse(todaysDate) ? 'on-demand' : 'upcoming';

            // Find the parent .webinar-instance element
            const webinarInstance = startDateElement.closest('.webinar-instance');
            if (webinarInstance) {
                webinarInstance.setAttribute('data-sort-status', pastOrFuture);
                webinarInstance.setAttribute('data-sort-value', sortVal);
            }
        });

        // Order webinars by date
        const webinarList = document.querySelector('.series-instances');
        const webinars = Array.from(document.querySelectorAll('.webinar-instance[data-sort-value]'));

        // Sort webinars by sort-value (same logic as jQuery version)
        webinars.sort((a, b) => {
            const aValue = parseInt(a.dataset.sortValue, 10);
            const bValue = parseInt(b.dataset.sortValue, 10);
            return aValue - bValue;
        });

        // Prepend sorted webinars to webinar list (same as jQuery prependTo)
        webinars.forEach((webinar) => {
            if (webinarList && webinarList.contains(webinar)) {
                webinarList.removeChild(webinar);
            }
        });
        webinars.forEach((webinar) => {
            if (webinarList) {
                webinarList.insertBefore(webinar, webinarList.firstChild);
            }
        });

        // Display future webinars first (upcoming) then past webinars (on-demand)
        const pastWebinars = Array.from(document.querySelectorAll('.webinar-instance[data-sort-status="on-demand"]'));
        const futureWebinars = Array.from(document.querySelectorAll('.webinar-instance[data-sort-status="upcoming"]'));

        // Prepend past webinars first (so they end up after future webinars)
        pastWebinars.forEach((webinar) => {
            if (webinarList && webinarList.contains(webinar)) {
                webinarList.removeChild(webinar);
            }
        });
        pastWebinars.forEach((webinar) => {
            if (webinarList) {
                webinarList.insertBefore(webinar, webinarList.firstChild);
            }
        });

        // Then prepend future webinars (so they end up first)
        futureWebinars.forEach((webinar) => {
            if (webinarList && webinarList.contains(webinar)) {
                webinarList.removeChild(webinar);
            }
        });
        futureWebinars.forEach((webinar) => {
            if (webinarList) {
                webinarList.insertBefore(webinar, webinarList.firstChild);
            }
        });
    }
}

registerComponent(`.${componentName}`, WebinarSeries);
